export class ArrayProcessor {
  static find<T>(items: Array<T>, predicate: (item: T) => boolean, getChildItems: (item: T) => Array<T>): T {
    for (const item of items) {
      if (predicate(item)) {
        return item;
      }

      const childItems = getChildItems(item);
      const foundItem = this.find<T>(childItems, predicate, getChildItems);
      if (foundItem) {
        return foundItem;
      }
    }

    return null;
  }

  static getDepth<T>(items: Array<T>, getChildItems: (item: T) => Array<T>): number {
    const depth = this.getDepthHelper(items, getChildItems, 0, 1);
    return depth;
  }

  private static getDepthHelper<T>(items: Array<T>, getChildItems: (item: T) => Array<T>, depth: number, currentDepth: number): number {
    for (const item of items) {
      const childItems = getChildItems(item);
      if (childItems && childItems.length !== 0) {
        const newDepth = this.getDepthHelper(childItems, getChildItems, depth, currentDepth + 1);
        depth = Math.max(newDepth, depth);
      }
    }
    depth = Math.max(depth, currentDepth);
    return depth;
  }

  static groupBy(items, keyGetter) {
    const map = new Map();
    items.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection)
        map.set(key, [item]);
      else
        collection.push(item);
    });
    return map;
  }

  static flatten<T>(array: Array<T>, result = new Array<T>()): Array<T> {
    for (let index = 0, length = array.length; index !== length; index++) {
      const value = array[index];
      if (Array.isArray(value))
        this.flatten<T>(value, result);
      else
        result.push(value);
    }
    return result;
  }

  static sort<T>(items: Array<T>): Array<T> {
    return items.sort((a, b) => {
      if (a instanceof Date && b instanceof Date) {
        return a.getTime() - b.getTime();
      }
      return a < b ? -1 : a > b ? 1 : 0;
    });
  }

  static distinct<T>(items: Array<T>): Array<T> {
    const set = new Set(items);
    return Array.from(set);
  }
}
